import Button from 'design-system/src/components/Button/Button';
import { Modal, ModalTitle, ModalBody, ModalFooter } from 'design-system/src/components/Modal';
import { Typography } from 'design-system/src/components/Typography/Typography';

export type MissingFaxNumberModalProps = {
  /**
   * Callback when the modal is closed
   */
  onClose: () => void;
  /**
   * Callback when the "Add providers" button is clicked
   */
  onAddProviders: () => void;
};

/**
 * Modal prompting the user to add providers when their fax number is not listed
 */
export const MissingFaxNumberModal = ({ onClose, onAddProviders }: MissingFaxNumberModalProps) => {
  return (
    <Modal onClose={onClose} maxWidth="544px">
      <ModalTitle className="!p-8 !pb-0">I don&apos;t see my fax number</ModalTitle>

      <ModalBody className="!gap-6 !p-8 !pt-6">
        <Typography styledAs="bodySmallDMSans" color="var(--grayscale-600)">
          Add more provider NPIs to see their associated fax numbers. Once a provider is added, their fax numbers
          usually appear within 1–2 hours.
        </Typography>
      </ModalBody>

      <ModalFooter className="!justify-start !px-8 !pb-8">
        <Button onClick={onAddProviders}>Add providers</Button>
      </ModalFooter>
    </Modal>
  );
};

export default MissingFaxNumberModal;
